import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { RfpProOfferCompleteView } from '@/components/pages/rfp/professional/RfpProOfferCompleteView/RfpProOfferCompleteView';
import Layout from '@/container/Layout';
import { usePageViewAction } from '@/hooks/action/pageView/usePageViewAction';
import { useBoolState } from '@/hooks/state/useBoolState';
const title = '提案完了';
/**
 * コンサルタント：案件提案提出のページ全体を表示する
 */
export const RfpProOfferCompletePage = (props) => {
    const { rfp } = props;
    // ×ボタン押下イベント
    const { createUserPageView: createPageViewActionHidePredictMemo } = usePageViewAction({
        action: 'rfp',
        actionId: rfp.id,
        subAction: 'offer_complete_close_modal',
    });
    // FB導線表示状態 管理
    const { boolState: isShow, changeFalse: onClickClose } = useBoolState({
        callbackChangeFalse: createPageViewActionHidePredictMemo,
        initialState: true,
    });
    // PDFダウンロードイベント
    const { createUserPageView: onClickDownload } = usePageViewAction({
        action: 'rfp',
        actionId: rfp.id,
        subAction: 'offer_complete_pdf_download',
    });
    // 申し込みボタン押下イベント
    const { createUserPageView: onClickOpenForm } = usePageViewAction({
        action: 'rfp',
        actionId: rfp.id,
        subAction: 'offer_complete_open_form',
    });
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${title}｜PROFFIT` }) }), _jsx(RfpProOfferCompleteView, { isShowOfFbLeadContent: isShow, onClickCloseOfFbLeadContent: onClickClose, onClickDownloadOfFbLeadContent: onClickDownload, onClickOpenFormOfFbLeadContent: onClickOpenForm, rfpId: rfp.id, rfpName: rfp.name })] })));
};
